import { useCallback, useEffect, useMemo, useState } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { updateDynamicStyleIds } from '@alltrails/maps/redux/reducer';
import { useAppDispatch, useAppSelector } from '../redux/helpers';

const useFallFoliageTierValidation = () => {
  const dispatch = useAppDispatch();
  const dynamicStyleIds = useAppSelector(state => state.map.dynamicStyleIds);
  const user = useUser();

  const [hasShownFoliageUpsellModal, setHasShownFoliageUpsellModal] = useState(false);
  const [showFoliageUpsellModal, setShowFoliageUpsellModal] = useState(false);
  const onFoliageUpsellModalCloseRequest = useCallback(() => setShowFoliageUpsellModal(false), []);
  const [foliageUpsellModalApplyStylesCallback, setFoliageUpsellModalApplyStylesCallback] = useState<() => void>();

  const handleFoliageFailedEntitlementCheck = useCallback(async (applyStyles: () => void) => {
    setShowFoliageUpsellModal(true);
    setHasShownFoliageUpsellModal(true);
    setFoliageUpsellModalApplyStylesCallback(() => applyStyles);
  }, []);

  useEffect(
    () => {
      if (hasShownFoliageUpsellModal && !showFoliageUpsellModal) {
        // After the upsell modal is closed, if the user has the correct entitlement, apply the fall foliage overlay, otherwise, remove it
        if (user?.featureEntitlements?.includes('fall_foliage')) {
          foliageUpsellModalApplyStylesCallback?.();
        } else {
          dispatch(updateDynamicStyleIds(dynamicStyleIds.filter(id => id !== 'fallFoliage')));
        }
        setFoliageUpsellModalApplyStylesCallback(undefined);
      }
    },
    // We only want to check this when the modal closes (showFoliageUpsellModal becomes false).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showFoliageUpsellModal]
  );

  return useMemo(
    () => ({
      showFoliageUpsellModal,
      onFoliageUpsellModalCloseRequest,
      handleFoliageFailedEntitlementCheck
    }),
    [handleFoliageFailedEntitlementCheck, onFoliageUpsellModalCloseRequest, showFoliageUpsellModal]
  );
};

export default useFallFoliageTierValidation;
